/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".js-results");
  if (!container) return;

  // Convert NodeList to array
  const products = Array.from(
    container.querySelectorAll(".collection-product-card")
  );

  // Step 1: Separate available and sold out
  const available = products.filter((p) => p.dataset.available === "true");
  const soldOut = products.filter((p) => p.dataset.available === "false");

  // Step 2: Separate available products into sale and not sale
  const onSale = available.filter((p) => p.dataset.is_sale === "true");
  const regular = available.filter((p) => p.dataset.is_sale === "false");

  //   // Step 3: Among on-sale products, separate new vs old
  //   const newProducts = regular.filter((p) => p.dataset.is_new === "true");
  //   const oldProducts = regular.filter((p) => p.dataset.is_new === "false");

  // Step 4: Re-append in order you prefer
  // Example order: new & sale → regular & sale → available (not sale) → sold out
  [...available, ...soldOut].forEach((p) => container.appendChild(p)); 
});